<template>
  <div v-if="processing" class="fixed inset-0 z-50 flex items-center justify-center" style="pointer-events: all">
    <div class="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
    <div class="relative z-10 flex flex-col items-center justify-center p-6 text-white">
      <Spinner small :color="spinnerColor" :class="spinnerSize" />
      <span class="text-sm font-medium mt-3">{{ message || 'Processing payment...' }}</span>
    </div>
  </div>
</template>

<script>
import Spinner from '../layout/spinner.vue'

export default {
  name: 'PaymentProcessingSpinner',
  components: {
    Spinner,
  },
  props: {
    processing: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    spinnerColor: {
      type: String,
      default: 'border-t-white',
    },
    spinnerSize: {
      type: String,
      default: 'h-10 w-10',
    },
  },
  watch: {
    processing(newVal) {
      if (newVal) {
        // Use $nextTick to ensure DOM has been updated before any operations
        this.$nextTick(() => {
          document.body.style.overflow = 'hidden'
        })
      } else {
        this.$nextTick(() => {
          document.body.style.overflow = ''
        })
      }
    }
  },
  beforeUnmount() {
    // Ensure we restore normal scrolling if component is unmounted while processing
    document.body.style.overflow = ''
  }
}
</script>